module.exports = "<ngx-spinner bdColor=\"rgba(51, 51, 51, 0.8)\" size=\"default\" type=\"line-scale-party\" [fullScreen]=\"true\">\n</ngx-spinner>\n"